export enum WorkspaceDocumentInvolvementType {
  CREATED = 'created',
  CHECKED_OUT = 'checkedOut',
}
